import { createTheme } from '@mui/material/styles'
import config from 'config/config'
import '../styles/scss_variable.scss'

export const BoxWrapper = {
  padding: '20px 0',
  display: 'flex',
  justifyContent: 'flex-start',
  borderRadius: '1px',
  bgcolor: config.colors.verylightshadegray
}
export const SinglePageBoxWrapper = {
  display: 'flex',
  justifyContent: 'flex-start',
  borderRadius: '1px',
  bgcolor: config.colors.verylightshadegray
}

export const GridRow = {
  '& .name': { fontSize: '18px' }
}

export const WhiteWrapper = {
  padding: '20px 0',
  // padding: "20px 0 20px 10px",
  borderRadius: '1px',
  bgcolor: config.colors.white
}

export const DividerStyle = {
  width: '100%',
  margin: '-5px 0 30px',
  height: '5px',
  boxShadow: '0px 13px 0px 0px ' + config.colors.aliceblue,
  border: 'none'
}

export const PaginationItemStyle = {
  border: 'none',
  minWidth: '30px',
  height: '30px',
  color: config.colors.sonicSliver,
  backgroundColor: config.colors.white,
  opacity: 1,
  font: 'normal normal normal 14px/20px Source Sans Pro',
  '&.Mui-selected': {
    background: `${config.colors.prussianBlue} 0% 0% no-repeat padding-box`,
    color: config.colors.white
  },
  '&:hover': {
    backgroundColor: config.colors.pastelBlue
  }

}

export const ModalBox = {
  position: 'absolute',
  top: '50%',
  height: 'auto',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  maxHeight: 630,
  overflowY: 'auto',
  bgcolor: 'background.paper',
  outline: 'none',
  boxShadow: '1px 1px 12px 1px ' + config.colors.grey,
  borderRadius: '4px',
  padding: '13px 32px 32px 32px',
  fontFamily: config.fontfamily,
  boxSizing: 'border-box'
}

export const themeLayout = createTheme({
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: config.fontfamily
        }
      }
    }
  }
})

export const themeSidemenu = createTheme({
  palette: {
    primary: {
      main: config.colors.darkblue
    }
  },
  typography: {
    fontFamily: config.fontfamily + ' !important'
  },
  components: {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          height: '52px',
          '&.Mui-selected::after': {
            content: '""',
            position: 'absolute',
            top: 'auto',
            bottom: '-1px',
            left: '-1px',
            right: '-7px',
            width: '5px',
            height: '57px',
            backgroundColor: config.colors.darkblue
          },
          '&:hover': {
            backgroundColor: 'transparent'
          }
        }
      }
    }

  }
})

export const themeTopmenu = createTheme({
  palette: {
    primary: {
      main: config.colors.darkblue
    }
  },
  typography: {
    fontFamily: config.fontfamily + ' !important'
  },
  components: {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          height: '52px',
          '&.Mui-selected::after': {
            content: '""',
            position: 'absolute',
            top: 'auto',
            bottom: 0,
            left: '-1px',
            right: '-1px',
            width: 'auto',
            height: '5px',
            backgroundColor: config.colors.darkblue
          },
          '&:hover': {
            backgroundColor: 'transparent'
          }
        }
      }
    },
    PaginationItem: {
      '.Mui-selected': {
        background: 'green'
      }
    }
  }
})

export const logout = {
  '& .MuiOutlinedInput-input': {
    padding: '16.5px 5px'
  }
}

export const datepickerbox = {
  display: 'flex',
  width: '98%',
  flexDirection: 'row',
  alignItems: 'right',
  margin: '1rem',
  justifyContent: 'right',
  '& .css-iajp3t-MuiButtonGroup-root .MuiButtonGroup-grouped': {
    minWidth: '80px'
  }
}

export const tablecell = {
  fontFamily: config.fontfamily,
  color: config.colors.blueprimary,
  padding: '8px 16px 16px'
}

export const notablecell = {
  color: config.colors.black,
  borderBottom: 'none',
  padding: '1rem 0'
}

export const tableheader = {
  display: 'inline-block',
  color: config.colors.black,
  fontSize: config.font16,
  paddingBottom: '10px'
}

export const tablecellclick = {
  fontFamily: config.fontfamily + ' !important',
  color: config.colors.black,
  padding: '1rem 0'
}

export const tableheadercell = {
  fontFamily: config.fontfamily + ' !important',
  color: config.colors.blueprimary,
  padding: '8px 0',
  fontSize: config.font16,
  backgroundColor: config.colors.white,
  margin: '8px 0'
}

export const datepickercss = {
  background: config.colors.white,
  marginLeft: '5px',
  textTransform: 'capitalize',
  borderColor: config.colors.chinesesilver,
  color: config.colors.black,
  lineHeight: '35px',
  height: '35px'
}

export const textboxCss = {
  margin: '3px 0 0',
  height: '2.25rem',
  border: '1px solid #002a57',
  borderRadius: '4px',
  color: '#000',
  '& .MuiInputBase-input': {
    fontSize: 16,
    padding: '6px 14px'
  },
  '& .MuiInputBase-input.Mui-disabled': {
    background: '#e9f2fa'
  }
}
